// imports
import React, { useState, useCallback, useMemo, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import * as XLSX from 'xlsx';
import axios from 'axios';

import {Grid,
   Button, CircularProgress, Backdrop, TextField, Snackbar,
  Alert, IconButton, InputLabel, FormControl, MenuItem, Select,
  Dialog, DialogTitle, DialogContent, DialogActions,
  Typography
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import { API_BASE_URL, Heading_Text_Color, Menu_Back_Color, Menu_Text_Color }from '../../constant/constant';
import { decrypt } from '../../components/cryptoUtil';


const ExcelUploader = () => {

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);

  const [excelData, setExcelData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [fileName, setFileName] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [selectedTable, setSelectedTable] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchQuery, setSearchQuery] = useState('');
  const [fileSize, setFileSize] = useState(0);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [editRowIndex, setEditRowIndex] = useState(null);
  const [editRowData, setEditRowData] = useState({});




const [tableList, setTableList] = useState([]);
const [fieldList, setFieldList] = useState([]);
const [procedureList, setProcedureList] = useState([]);
const [selectedProcedure, setSelectedProcedure] = useState('');
const [procedureQuery, setProcedureQuery] = useState('');

const [currentFile, setCurrentFile] = useState(null);


const [firstRowIsHeader, setFirstRowIsHeader] = useState(false);


// Check if a number is a likely Excel serial date
function isLikelyExcelDate(n) {
  return n > 20000 && n < 60000; // approx range: 1954 - 2064
}

// Convert Excel serial to JS date string (e.g., "dd-mm-yyyy")
function formatExcelDate(serial) {
  const utcDays = Math.floor(serial - 25569); // Excel epoch starts at 1900-01-01
  const utcValue = utcDays * 86400; // seconds in a day
  const dateInfo = new Date(utcValue * 1000);
  const day = String(dateInfo.getUTCDate()).padStart(2, '0');
  const month = String(dateInfo.getUTCMonth() + 1).padStart(2, '0');
  const year = dateInfo.getUTCFullYear();
  return `${day}-${month}-${year}`;
}




  const showSnackbar = (message, severity = 'success') => {
    setSnackbar({ open: true, message, severity });
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ open: false, message: '', severity: 'success' });
  };

  // const onDrop = useCallback((acceptedFiles) => {
  //   const file = acceptedFiles[0];
  //   setFileName(file.name);
  //   setLoading(true);
  //   setFileSize(file.size);
  //   const reader = new FileReader();
  //   reader.onload = (evt) => {
  //     try {
  //       const bstr = evt.target.result;
  //       const workbook = XLSX.read(bstr, { type: 'binary' });
  //       const worksheet = workbook.Sheets[workbook.SheetNames[0]];
  //       const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

  //       const headers = jsonData[0];
  //       const rows = jsonData.slice(1).map((row, rowIndex) =>
  //         headers.reduce((obj, key, index) => {
  //           obj[key] = row[index] || '';
  //           return obj;
  //         }, { rowNo: rowIndex + 1 })
  //       );

  //      setColumns(['rowNo', ...headers]);

  //       setExcelData(rows);
  //       setSortConfig({ key: null, direction: 'asc' });
  //       setCurrentPage(1);
  //     } catch (err) {
  //       console.error(err);
  //       showSnackbar('❌ Failed to read Excel file.', 'error');
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   reader.readAsBinaryString(file);
  // }, []);

//   const onDrop = useCallback((acceptedFiles) => {
//     const file = acceptedFiles[0];
//     setFileName(file.name);
//     setLoading(true);
//     setFileSize(file.size);

//     const reader = new FileReader();
//     reader.onload = (evt) => {
//       try {
//        // const fileExtension = file.name.split('.').pop().toLowerCase();
//        const fileExtension = file.name.slice(((file.name.lastIndexOf('.') - 1) >>> 0) + 2).toLowerCase();

//         let workbook;

//         if (fileExtension === 'csv') {
//           const csvData = evt.target.result;
//           workbook = XLSX.read(csvData, { type: 'string' });
//         } else {
//           const binaryStr = evt.target.result;
//           workbook = XLSX.read(binaryStr, { type: 'binary' });
//         }

//         const worksheet = workbook.Sheets[workbook.SheetNames[0]];
//         // const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

//         // const headers = jsonData[0];
//         // const rows = jsonData.slice(1).map((row, rowIndex) =>
//         //   headers.reduce((obj, key, index) => {
//         //     obj[key] = row[index] || '';
//         //     return obj;
//         //   }, { rowNo: rowIndex + 1 })
//         // );

//         // setColumns(['rowNo', ...headers]);
//         // setExcelData(rows);
//    const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

// let headers = [];
// let dataRows = [];

// if (firstRowIsHeader) {
//   headers = jsonData[0];
//   dataRows = jsonData.slice(1);
// } else {
//   const maxCols = Math.max(...jsonData.map(row => row.length));
//   headers = Array.from({ length: maxCols }, (_, i) => `Col${i + 1}`);
//   dataRows = jsonData.map(row => {
//     // Fill missing columns with empty strings to match header length
//     const filledRow = Array.from({ length: maxCols }, (_, i) => row[i] || '');
//     return filledRow;
//   });
// }

// const rows = dataRows.map((row, rowIndex) =>
//   headers.reduce((obj, key, index) => {
//     obj[key] = row[index] || '';
//     return obj;
//   }, { rowNo: rowIndex + 1 })
// );

// setColumns(['rowNo', ...headers]);
// setExcelData(rows);


//         setSortConfig({ key: null, direction: 'asc' });
//         setCurrentPage(1);
//       } catch (err) {
//         console.error(err);
//         showSnackbar('❌ Failed to read file.', 'error');
//       } finally {
//         setLoading(false);
//       }
//     };

//     const fileExtension = file.name.split('.').pop().toLowerCase();
//     if (fileExtension === 'csv') {
//       reader.readAsText(file);
//     } else {
//       reader.readAsBinaryString(file);
//     }
//   }, []);


// const onDrop = useCallback((acceptedFiles) => {
//   const file = acceptedFiles[0];
//   setFileName(file.name);
//   setFileSize(file.size);
//   setLoading(true);
//   setCurrentFile(file); // for useEffect optional reprocessing

//   const reader = new FileReader();

//   reader.onload = (evt) => {
//     try {
//       const fileExtension = file.name.split('.').pop().toLowerCase();
//       let workbook;
//       let jsonData = [];

//       if (fileExtension === 'csv') {
//         const csvStr = evt.target.result;

//         // Convert CSV string into worksheet
//         const worksheet = XLSX.read(csvStr, { type: 'string', raw: false }).Sheets.Sheet1;
//         jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

//       } else {
//         const binaryStr = evt.target.result;
//         workbook = XLSX.read(binaryStr, { type: 'binary' });
//         const worksheet = workbook.Sheets[workbook.SheetNames[0]];
//         jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
//       }

//       // Handle headers and data rows
//       let headers = [];
//       let dataRows = [];

//       if (firstRowIsHeader) {
//         headers = jsonData[0];
//         dataRows = jsonData.slice(1);
//       } else {
//         const maxCols = Math.max(...jsonData.map(row => row.length));
//         headers = Array.from({ length: maxCols }, (_, i) => `Col${i + 1}`);
//         dataRows = jsonData.map(row => {
//           const filledRow = Array.from({ length: maxCols }, (_, i) => row[i] || '');
//           return filledRow;
//         });
//       }

//       const rows = dataRows.map((row, rowIndex) =>
//         headers.reduce((obj, key, index) => {
//           obj[key] = row[index] || '';
//           return obj;
//         }, { rowNo: rowIndex + 1 })
//       );

//       setColumns(['rowNo', ...headers]);
//       setExcelData(rows);
//       setSortConfig({ key: null, direction: 'asc' });
//       setCurrentPage(1);
//     } catch (err) {
//       console.error(err);
//       showSnackbar('❌ Failed to read file.', 'error');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fileExtension = file.name.split('.').pop().toLowerCase();
//   if (fileExtension === 'csv') {
//     reader.readAsText(file); // read CSV as plain text
//   } else {
//     reader.readAsBinaryString(file); // Excel as binary
//   }
// }, [firstRowIsHeader]);

const onDrop = useCallback((acceptedFiles) => {
  const file = acceptedFiles[0];
  setFileName(file.name);
  setFileSize(file.size);
  setLoading(true);
  setCurrentFile(file); // for useEffect optional reprocessing

  const reader = new FileReader();

  reader.onload = (evt) => {
    try {
      const fileExtension = file.name.split('.').pop().toLowerCase();
      let workbook;
      let jsonData = [];

      if (fileExtension === 'csv') {
        const csvStr = evt.target.result;

        // Read CSV with raw mode to preserve leading zeros
        workbook = XLSX.read(csvStr, {
          type: 'string',
          raw: true,
        });

        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1, raw: true });

      } else {
        const binaryStr = evt.target.result;
        workbook = XLSX.read(binaryStr, { type: 'binary' });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      }

      // Handle headers and data rows
      let headers = [];
      let dataRows = [];

      if (firstRowIsHeader) {
        headers = jsonData[0];
        dataRows = jsonData.slice(1);
      } else {
        const maxCols = Math.max(...jsonData.map(row => row.length));
        headers = Array.from({ length: maxCols }, (_, i) => `Col${i + 1}`);
        dataRows = jsonData.map(row => {
          const filledRow = Array.from({ length: maxCols }, (_, i) => row[i] || '');
          return filledRow;
        });
      }

      // Force all cell values to be strings (preserve 001, 000045, etc.)
      dataRows = dataRows.map(row =>
       // row.map(cell => (cell !== undefined && cell !== null ? String(cell) : ''))
      
      row.map(cell => {
    if (typeof cell === 'number' && isLikelyExcelDate(cell)) {
      return formatExcelDate(cell); // Convert to readable date
    }
    return cell !== undefined && cell !== null ? String(cell) : '';
  })
      );

      const rows = dataRows.map((row, rowIndex) =>
        headers.reduce((obj, key, index) => {
          obj[key] = row[index] || '';
          return obj;
        }, { rowNo: rowIndex + 1 })
      );

      setColumns(['rowNo', ...headers]);
      setExcelData(rows);
      setSortConfig({ key: null, direction: 'asc' });
      setCurrentPage(1);
    } catch (err) {
      console.error(err);
      showSnackbar('❌ Failed to read file.', 'error');
    } finally {
      setLoading(false);
    }
  };

  const fileExtension = file.name.split('.').pop().toLowerCase();
  if (fileExtension === 'csv') {
    reader.readAsText(file); // Read CSV as plain text
  } else {
    reader.readAsBinaryString(file); // Read Excel as binary
  }
}, [firstRowIsHeader]);


useEffect(() => {
  if (currentFile) {
    onDrop([currentFile]);
  }
}, [firstRowIsHeader]);




  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'application/vnd.ms-excel': ['.xls'],
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
      'text/csv': ['.csv'],
    },
  });

  const handleUploadToServer = async () => {
   // if (!selectedTable) return showSnackbar('⚠️ Please select a table before uploading.', 'warning');
    try {

      setUploading(true);
      await axios.post(`${API_BASE_URL}/upload-excel`, {
        data: excelData.map(({ rowNo, ...rest }) => rest),
        tableName: selectedTable,
      });
     //   console.log('👉 First row of data:', excelData[0]);
   // console.log('👉 Keys used for insert:', Object.keys(excelData[0] || {}));

      showSnackbar('✅ Data uploaded successfully!');
    } catch (error) {
      console.error('Upload error:', error);
      showSnackbar('❌ Upload failed.', 'error');
    } finally {
      setUploading(false);
    }
  };

  const handleSort = (column) => {
    if (column === 'rowNo') return;

    setLoading(true);
    setTimeout(() => {
      setSortConfig((prev) => {
        if (prev.key === column) {
          return {
            key: column,
            direction: prev.direction === 'asc' ? 'desc' : 'asc',
          };
        } else {
          return { key: column, direction: 'asc' };
        }
      });
      setCurrentPage(1);
      setLoading(false);
    }, 200);
  };

  const handleEditRow = (index) => {
    setEditRowIndex(index);
    setEditRowData({ ...excelData[index] });
  };

  const handleSaveRow = () => {
    const updated = [...excelData];
    updated[editRowIndex] = { ...editRowData, rowNo: editRowIndex + 1 };
    setExcelData(updated);
    setEditRowIndex(null);
    setEditRowData({});
    showSnackbar('Row updated.');
  };

  const handleDeleteRow = (index) => {
    const updated = [...excelData];
    updated.splice(index, 1);
    updated.forEach((r, i) => (r.rowNo = i + 1)); // reassign row numbers
    setExcelData(updated);
    showSnackbar('Row deleted.');
  };

  const filteredData = useMemo(() => {
    if (!searchQuery) return excelData;
    return excelData.filter((row) =>
      Object.values(row).some(
        (val) => val?.toString().toLowerCase().includes(searchQuery.toLowerCase())
      )
    );
  }, [excelData, searchQuery]);

  const sortedData = useMemo(() => {
    if (!sortConfig.key) return filteredData;
    return [...filteredData].sort((a, b) => {
      const valA = a[sortConfig.key] ?? '';
      const valB = b[sortConfig.key] ?? '';
      return (valA > valB ? 1 : valA < valB ? -1 : 0) * (sortConfig.direction === 'asc' ? 1 : -1);
    });
  }, [filteredData, sortConfig]);

  const paginatedData = useMemo(() => {
    const start = (currentPage - 1) * pageSize;
    return sortedData.slice(start, start + pageSize);
  }, [sortedData, currentPage, pageSize]);

  const totalPages = Math.ceil(sortedData.length / pageSize);

  const handleExportCSV = () => {
    const headers = columns.slice(1);
    const dataToExport = sortedData.map(row => headers.map(h => row[h]));
    const exportData = [headers, ...dataToExport];
    const worksheet = XLSX.utils.aoa_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Export');
    XLSX.writeFile(workbook, 'exported_data.csv');
  };












// useEffect(() => {
//   const fetchTables = async () => {
//     try {
//       const res = await axios.get(`${API_BASE_URL}/tables`);
//       setTableList(res.data);
//     } catch (err) {
//       console.error(err);
//       showSnackbar('❌ Failed to fetch table list.', 'error');
//     }
//   };

//   fetchTables();
 
// }, []);

 const UserDetails = (JSON.parse(decrypt(localStorage.getItem('tokenData'))));
const [prefix, setPrefix] = useState(`${UserDetails.softgroup}_`); 
useEffect(() => {
  const fetchSoftwarelist = async () => {
    try {
      // setLoadingSoftwares(true);
      const res = await axios.get(`${API_BASE_URL}/api/tables?prefix=${prefix}`, {
        withCredentials: true, // optional
      });
      setTableList(res.data || []);
    //  console.log('Fetched table list:', res.data);
    } catch (err) {
      console.error(err);
    } finally {
      // setLoadingSoftwares(false);
    }
  };
  fetchSoftwarelist();
}, []);










  return (
    <div style={{ padding: 20 }}>
      <Backdrop open={loading || uploading} style={{ zIndex: 9999, color: '#fff' }}>
        <CircularProgress color="inherit" />
        <span style={{ marginLeft: 10 }}>{uploading ? 'Uploading...' : 'Loading...'}</span>
      </Backdrop>

      <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={handleCloseSnackbar}>
        <Alert severity={snackbar.severity} onClose={handleCloseSnackbar}>
          {snackbar.message}
        </Alert>
      </Snackbar>

      <Grid container alignItems="center" justifyContent="space-between" style={{ marginBottom: 16 }}>
        {/* <Grid>
          <h2 gutterBottom style={{ color: Heading_Text_Color, textAlign: 'center' }}>📁 Excel/CSV Files Uploader</h2>
        </Grid> */}

        <Typography gutterBottom style={{ color: Heading_Text_Color,  fontSize: '1.25rem'   }}>
📁 Excel/CSV Files Uploader
             </Typography>
        <Grid>


 <div>

    <FormControl fullWidth size="small">
      <InputLabel>First Row Header?</InputLabel>
      <Select
        value={firstRowIsHeader ? 'yes' : 'no'}
        size='small'
        onChange={(e) => setFirstRowIsHeader(e.target.value === 'yes')}
        label="First Row Header?"
      >
        <MenuItem value="yes">✅ Yes</MenuItem>
        <MenuItem value="no">❌ No (Auto Col1, Col2...)</MenuItem>
      </Select>
    </FormControl>
 
</div>

















          {excelData.length > 0 && (
            <Button
              variant="outlined"
              color="secondary"
             
             
              onClick={() => {
                setExcelData([]);
                setColumns([]);
                setFileName('');
                setSortConfig({ key: null, direction: 'asc' });
                setLoading(false);
                setUploading(false);
                setSelectedTable('');
                setCurrentPage(1);
                setPageSize(10);
                setSearchQuery('');
                setFileSize(0);
                setEditRowIndex(null);
                setEditRowData({});
                showSnackbar('🧹 Cleared all uploaded data.');
              }}
            >
              🔄 Refresh
            </Button>
          )}
        </Grid>
      </Grid>


      <div
        {...getRootProps()}
        style={{
          border: '2px dashed #007bff',
          padding: 40,
          borderRadius: 10,
          backgroundColor: isDragActive ? '#e6f0ff' : '#f9f9f9',
          textAlign: 'center',
          cursor: 'pointer',
          marginBottom: 20,
        }}
      >
        <input {...getInputProps()} />
        <p>{isDragActive ? 'Drop the Data file here...' : 'Drag & drop an Data file or click to browse'}</p>
        <em>Accepted formats: .xlsx, .xls, .csv</em>
      </div>





      {excelData.length > 0 && (
        <>




          <Grid container spacing={2} alignItems="center" marginBottom={2}>


            <Grid xs={12} sm={6} md={2}>
              <FormControl fullWidth size="small" width='150px'>
                <InputLabel>Page Size</InputLabel>
                <Select value={pageSize} onChange={(e) => setPageSize(Number(e.target.value))}>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={25}>25</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                  <MenuItem value={100}>100</MenuItem>
                  <MenuItem value={500}>500</MenuItem>
                  <MenuItem value={1000}>1000</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid xs={12} sm={6} md={4}>
              <TextField
                size="small"
                fullWidth
                label="🔍 Search"
                value={searchQuery}
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                  setCurrentPage(1);
                }}
              />
            </Grid>

            <Grid xs={6} sm={3} md={2}>
              <Button variant="contained" fullWidth onClick={handleExportCSV}>📥 Export to CSV</Button>
            </Grid>


          </Grid>









          <p><strong>Rows:</strong> {filteredData.length} | <strong>Columns:</strong> {columns.length} | <strong>File Size:</strong> {fileSize >= 1024 * 1024 ? `${(fileSize / 1024 / 1024).toFixed(2)} MB` : `${(fileSize / 1024).toFixed(2)} KB`}</p>


          <div style={{ maxHeight: 600, overflow: 'auto' }}>
            <table style={{ borderCollapse: 'collapse', width: '100%' }} border="1" cellPadding="6">
              <thead>
                <tr>
                  {columns.map((col, i) => (
                    <th
                      key={i}
                      onClick={() => handleSort(col)}
                      style={{
                        background: Menu_Back_Color,
                        color: Menu_Text_Color,
                        position: 'sticky',
                        top: 0,
                        cursor: col !== 'rowNo' ? 'pointer' : 'default',
                      }}
                    >
                      {col === 'rowNo' ? 'Row No' : col}
                      {sortConfig.key === col && (sortConfig.direction === 'asc' ? ' 🔼' : ' 🔽')}
                    </th>
                  ))}

                  <th  style={{
                        background: Menu_Back_Color,
                        color: Menu_Text_Color,
                        position: 'sticky',
                        top: 0,
                       
                      }} >Actions</th>
                </tr>
              </thead>
              <tbody>
                {paginatedData.map((row, index) => (
                  <tr
                    key={index}
                    onDoubleClick={() => {
                      setSelectedRowData(row);
                      setOpenDialog(true);
                    }}
                    style={{ cursor: "pointer" }}
                  >

                    {columns.map((col, i) => (
                      <td key={i}>
                        {editRowIndex === index && col !== 'rowNo' ? (
                          <TextField
                            value={editRowData[col] ?? ''}
                            onChange={(e) =>
                              setEditRowData((prev) => ({ ...prev, [col]: e.target.value }))
                            }
                            size="small"
                            variant="outlined"
                          />
                        ) : (
                          row[col]
                        )}
                      </td>
                    ))}
                    <td>
                      {editRowIndex === index ? (
                        <IconButton onClick={handleSaveRow}><SaveIcon /></IconButton>
                      ) : (
                        <IconButton onClick={() => handleEditRow(index)}><EditIcon /></IconButton>
                      )}
                      <IconButton color="error" onClick={() => handleDeleteRow(index)}>
                        <DeleteIcon />
                      </IconButton>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div style={{ textAlign: 'center', marginTop: 10 }}>
            <Button onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))} disabled={currentPage === 1}>⬅ Prev</Button>
            <span style={{ margin: '0 15px' }}>Page {currentPage} of {totalPages}</span>
            <Button onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))} disabled={currentPage === totalPages}>Next ➡</Button>
          </div>

          
<Grid container spacing={2} alignItems="center" justifyContent="flex-end" marginBottom={2}>
  <Grid xs={12} sm={6} md={4}>
    <FormControl size="small" sx={{ width: '150px' }}>
      <InputLabel>Select Table</InputLabel>
      <Select
        value={selectedTable}
        onChange={(e) => setSelectedTable(e.target.value)}
        label="Select Table"
        
      >
        <MenuItem value="" >
          <em>-- Select Table --</em>
        </MenuItem>
      
       {/* {tableList.map((table, index) => (
          <MenuItem key={index} value={table}>{table}</MenuItem>
        ))} */}
{/* 'cr_data', 'dr_data', */}
  {tableList
          .filter(table => ['rib_uploaded_data'].includes(table))
          .map((table, index) => (
            <MenuItem key={index} value={table}>{table}</MenuItem>
          ))
        }


      </Select>
    </FormControl>
  </Grid>

  <Grid xs={6} sm={3} md={2}>
    <Button
    disabled={!selectedTable}
      variant="contained"
      color="primary"
      fullWidth
      onClick={handleUploadToServer}
    >
      🚀 Upload
    </Button>
  </Grid>
</Grid>




        </>


      )}



      {/* Dialog for Row Details */}
      {selectedRowData && (
        <Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth maxWidth="sm">
          <DialogTitle>📋 Row Details</DialogTitle>

<TextField
  fullWidth
  multiline
  label="Query Text"
  variant="outlined"
  value={columns
    .filter(col => col !== 'rowNo')
    .map(col => `${col}: ${selectedRowData[col] ?? ''}`)
    .join('\n')}
  InputProps={{ readOnly: true }}
  sx={{ marginTop: 2 }}
/>




          <DialogContent dividers>
            <Grid container spacing={2} id="print-area">
              {columns
                .filter(col => col !== 'Row No')
                .map((col, i) => (
                  <Grid xs={12} sm={6} key={i}>
                    <strong>{col}:</strong> {selectedRowData[col]?.toString() ?? ''}
                  </Grid>
                ))}
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                const text = columns
                  .filter(col => col !== 'Row No')
                  .map(col => `${col}: ${selectedRowData[col]}`)
                  .join('\n');
                navigator.clipboard.writeText(text);
                showSnackbar('✅ Copied to clipboard!');
              }}
            >
              📋 Copy
            </Button>
            <Button
              onClick={() => {
                const printContent = document.getElementById('print-area').innerHTML;
                const printWindow = window.open('', '', 'height=600,width=800');
                printWindow.document.write('<html><head><title>Row Details</title></head><body>');
                printWindow.document.write('<h3>Row Details</h3>');
                printWindow.document.write(printContent);
                printWindow.document.write('</body></html>');
                printWindow.document.close();
                printWindow.print();
              }}
            >
              🖨️ Print
            </Button>
            <Button onClick={() => setOpenDialog(false)} color="primary">Close</Button>
          </DialogActions>
        </Dialog>



      )}


    </div>






  );
};

export default ExcelUploader;
